exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryListPopUp-ListContainer-Alerts{background-color:#fff}.HistoryListPopUp-ListContainer-Alert_container{padding:0 15px;padding:0 .9375rem;margin:0 auto;max-width:1280px}", ""]);

// exports
exports.locals = {
	"Alerts": "HistoryListPopUp-ListContainer-Alerts",
	"Alert_container": "HistoryListPopUp-ListContainer-Alert_container"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/HistoryListPopUp/ListContainer.css
// module id = 1087
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20